import React  from "react";
import { useContext } from "react";

import cross from '../../assets/orders/cross.svg'
import ModalContext from '../../contexts/ModalContext';
import SectionContext from '../../contexts/SectionContext';
import FreightModal from './freightContent/freightForm'
import FreightContent from "./freightContent";
import VehicleContent from "./vehicleContent";
import ClientContent from "./clientContent";
import {
    Container,
    HeaderDiv,
    HeaderText,
    CloseDiv,
    CloseImg
} from "./style"
import RouterContent from "./routerContent";




const RouterModal = ()=>{

    const { setModalActive, setModalSection } = useContext(ModalContext);
    const {routerSection, setRouterSection} = useContext(SectionContext);


    const handleClick = ()=>{
        setModalSection('router')
        setModalActive(true);
    }
    
    
    const RoutersModal = ()=>{
        return(
            <Container>
                <HeaderDiv>
                    <HeaderText>Novo Roteiro</HeaderText>
                    <CloseDiv onClick={() => setModalActive(false)}>
              <CloseImg src={cross} alt='Close tab' />
              </CloseDiv>
                </HeaderDiv>
                <h1>ROTEIRO</h1>
            </Container>
        )
    }
    
    if(routerSection.includes('freight')){
        return(
            <FreightContent />
            
        )
    }else if(routerSection.includes('vehicle')){
        return(
            <VehicleContent/>
            
        )
    }else if(routerSection.includes('client')){
        return(
            <ClientContent/>
            
        )
    }else if(routerSection.includes('route')){
        return(
            <RouterContent/>
        )
    }
   

}

export default RouterModal